import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icon/caret-left-grey-with-background.png'


const _withScopeId = n => (_pushScopeId("data-v-5cdd52d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fueling-transaction-detail-card" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-center justify-center p-12 min-h-[400px]"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-4 text-neutral-500 font-medium" }, "Memuat detail transaksi...", -1))
const _hoisted_4 = { class: "flex flex-col md:flex-row md:items-center justify-between gap-4 border-b border-neutral-100 pb-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-file text-blue-500 text-xl" }),
  /*#__PURE__*/_createElementVNode("h2", { class: "text-xl md:text-2xl font-bold text-neutral-800" }, "Detail Transaksi")
], -1))
const _hoisted_6 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6 py-6 border-b border-neutral-100" }
const _hoisted_7 = { class: "flex flex-col gap-3.5 border-r border-dashed border-neutral-200 pr-6 last:border-0" }
const _hoisted_8 = { class: "flex flex-wrap items-center gap-3" }
const _hoisted_9 = { class: "text-lg font-bold text-neutral-800" }
const _hoisted_10 = { class: "text-sm font-semibold text-neutral-700 mt-1" }
const _hoisted_11 = { class: "md:grid grid-cols-3 items-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-500 shrink-0" }, "Nopol:", -1))
const _hoisted_13 = { class: "font-bold text-neutral-800 col-span-2 text-sm" }
const _hoisted_14 = { class: "md:grid grid-cols-3 items-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-500 shrink-0" }, "No. Lambung:", -1))
const _hoisted_16 = { class: "font-bold text-neutral-800 col-span-2 text-sm" }
const _hoisted_17 = { class: "md:grid grid-cols-3 items-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-500 shrink-0" }, "Nama Kru:", -1))
const _hoisted_19 = { class: "font-bold text-neutral-800 col-span-2 text-sm" }
const _hoisted_20 = { class: "md:grid grid-cols-3 items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-500 shrink-0" }, "Jenis Transaksi:", -1))
const _hoisted_22 = { class: "font-bold text-neutral-800 col-span-2 text-sm" }
const _hoisted_23 = { class: "flex flex-col gap-3.5 border-r border-dashed border-neutral-200 pr-6 last:border-0" }
const _hoisted_24 = { class: "md:grid grid-cols-3 items-center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-500 shrink-0" }, "Kode PP:", -1))
const _hoisted_26 = { class: "font-bold text-neutral-800 col-span-2 text-sm truncate relative group cursor-help" }
const _hoisted_27 = { class: "md:grid grid-cols-3 items-center" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-500 shrink-0" }, "Kupon BBM:", -1))
const _hoisted_29 = { class: "font-bold text-neutral-800 col-span-2 text-sm" }
const _hoisted_30 = { class: "md:grid grid-cols-3 items-center" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-500 shrink-0" }, "Pembelian:", -1))
const _hoisted_32 = { class: "font-bold text-neutral-800 col-span-2 text-sm" }
const _hoisted_33 = { class: "md:grid grid-cols-3 items-center" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-500 shrink-0" }, "Nominal (Rp):", -1))
const _hoisted_35 = { class: "font-bold text-neutral-800 col-span-2 text-sm" }
const _hoisted_36 = { class: "md:grid grid-cols-3 items-center" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-500 shrink-0" }, "Nama Operator Pom:", -1))
const _hoisted_38 = { class: "font-bold text-neutral-800 col-span-2 text-sm" }
const _hoisted_39 = { class: "md:grid grid-cols-3 items-center" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-500 shrink-0" }, "Pom Mitra:", -1))
const _hoisted_41 = { class: "font-bold text-neutral-800 col-span-2 text-sm" }
const _hoisted_42 = { class: "py-6 border-b border-neutral-100" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-bold text-neutral-800 mb-4" }, "Bukti Transaksi", -1))
const _hoisted_44 = { class: "grid grid-cols-1 md:grid-cols-3 gap-6" }
const _hoisted_45 = { class: "flex flex-col gap-2" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-500 font-medium" }, "Foto Meteran:", -1))
const _hoisted_47 = { class: "w-full h-48 rounded-lg overflow-hidden flex items-center justify-center bg-neutral-100 border border-neutral-200 group relative" }
const _hoisted_48 = {
  key: 1,
  class: "text-neutral-600 flex flex-col items-center gap-2 text-xs"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-image text-3xl text-neutral-300" }, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tidak ada foto meteran", -1))
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = { class: "flex flex-col gap-2" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-500 font-medium" }, "Foto Nopol:", -1))
const _hoisted_54 = { class: "w-full h-48 rounded-lg overflow-hidden flex items-center justify-center bg-neutral-100 border border-neutral-200 group relative" }
const _hoisted_55 = {
  key: 1,
  class: "text-neutral-600 flex flex-col items-center gap-2 text-xs"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-image text-3xl text-neutral-300" }, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tidak ada foto nopol", -1))
const _hoisted_58 = [
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = { class: "flex flex-col gap-2" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-500 font-medium" }, "Foto Nota:", -1))
const _hoisted_61 = { class: "w-full h-48 rounded-lg overflow-hidden flex items-center justify-center bg-neutral-100 border border-neutral-200 group relative" }
const _hoisted_62 = {
  key: 1,
  class: "text-neutral-600 flex flex-col items-center gap-2 text-xs"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-image text-3xl text-neutral-300" }, null, -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tidak ada foto nota", -1))
const _hoisted_65 = [
  _hoisted_63,
  _hoisted_64
]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-bold text-neutral-800 mb-4" }, "Keterangan", -1))
const _hoisted_67 = {
  key: 0,
  class: "md:grid grid-cols-3 mb-2"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 text-sm" }, "Perubahan Liter:", -1))
const _hoisted_69 = { class: "flex items-center gap-3 col-span-2" }
const _hoisted_70 = { class: "text-sm font-bold text-neutral-800" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ">"
}, null, -1))
const _hoisted_72 = { class: "text-sm font-bold text-neutral-800" }
const _hoisted_73 = {
  key: 1,
  class: "md:grid grid-cols-3 mb-2"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 text-sm" }, "Perubahan Nominal:", -1))
const _hoisted_75 = { class: "flex items-center gap-3 col-span-2" }
const _hoisted_76 = { class: "text-sm font-bold text-neutral-800" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ">"
}, null, -1))
const _hoisted_78 = { class: "text-sm font-bold text-neutral-800" }
const _hoisted_79 = { class: "flex items-start gap-3" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-500 w-20 shrink-0" }, "Alasan:", -1))
const _hoisted_81 = { class: "flex-1" }
const _hoisted_82 = { key: 0 }
const _hoisted_83 = {
  key: 1,
  class: "text-sm font-bold text-neutral-800"
}
const _hoisted_84 = {
  key: 1,
  class: "text-sm font-bold text-neutral-800"
}
const _hoisted_85 = {
  key: 0,
  class: "mt-4 md:mt-0"
}
const _hoisted_86 = { class: "flex flex-col gap-2" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-500 font-medium" }, "Bukti Revisi:", -1))
const _hoisted_88 = ["src"]
const _hoisted_89 = { class: "py-6" }
const _hoisted_90 = {
  key: 0,
  class: "mt-4 flex flex-col gap-2 min-w-0"
}
const _hoisted_91 = { class: "text-sm text-neutral-500" }
const _hoisted_92 = { class: "font-bold text-neutral-700" }
const _hoisted_93 = { class: "flex border-b border-neutral-200 mt-2" }
const _hoisted_94 = { class: "border border-neutral-200 rounded-lg overflow-hidden w-full relative min-h-[200px] mt-2" }
const _hoisted_95 = {
  key: 0,
  class: "absolute inset-0 bg-white/80 flex items-center justify-center z-10"
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center p-8 text-neutral-500" }, "Tidak ada riwayat pengisian.", -1))
const _hoisted_97 = {
  key: 0,
  class: "text-blue-500 text-xs ml-1 font-medium"
}
const _hoisted_98 = { class: "font-semibold text-neutral-800" }
const _hoisted_99 = {
  key: 0,
  class: "flex justify-center mt-2"
}
const _hoisted_100 = { class: "flex items-center justify-end mt-4" }
const _hoisted_101 = /*#__PURE__*/_createTextVNode("Kembali")

import { onMounted, withDefaults } from 'vue'
import moment from 'moment'
import Card from 'primevue/card'
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ProgressSpinner from 'primevue/progressspinner'
import Paginator from '@/views/components/paginator/Paginator.vue'
import ImageViewer from '@/views/shared-components/ImageViewer.vue'
import { useApprovalStatus } from '@/composables/useApprovalStatus'
import numberFormat from '@/utils/helpers/numberFormat'
import { getTransactionTypeLabel, getFullImageUrl, formatRupiah } from '@/utils/helpers/fuelTransactionHelper'
import { IFuelingTransactionDetail, IFuelingTransactionHistoryItem } from '@/utils/interfaces/iFuelMonitoring'

interface Props {
  transactionDetail: IFuelingTransactionDetail | null
  isLoadingDetail?: boolean
  historyData?: IFuelingTransactionHistoryItem[]
  isLoadingHistory?: boolean
  activeHistoryTab?: 'nopol' | 'kru'
  historyPaginate?: {
    pageSize: number
    pageNumber: number
    totalRecords: number
  }
  isHistoryVisible?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FuelingTransactionDetailCard',
  props: {
    transactionDetail: null,
    isLoadingDetail: { type: Boolean, default: false },
    historyData: { default: () => [] },
    isLoadingHistory: { type: Boolean, default: false },
    activeHistoryTab: { default: 'nopol' },
    historyPaginate: { default: () => ({
    pageSize: 10,
    pageNumber: 1,
    totalRecords: 0
  }) },
    isHistoryVisible: { type: Boolean, default: false }
  },
  emits: ["update:activeHistoryTab", "update:isHistoryVisible", "change-history-tab", "change-history-page", "toggle-history", "back", "view-evidence"],
  setup(__props: any) {





const {
  fetchApprovalStatuses,
  getDynamicStatusColor,
  getDynamicStatusBg,
  getDynamicStatusText
} = useApprovalStatus()

onMounted(() => {
  fetchApprovalStatuses()
})

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.isLoadingDetail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(ProgressSpinner), {
            style: {"width":"50px","height":"50px"},
            strokeWidth: "4"
          }),
          _hoisted_3
        ]))
      : (__props.transactionDetail)
        ? (_openBlock(), _createBlock(_unref(Card), {
            key: 1,
            class: "card-no-shadow mb-4"
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _renderSlot(_ctx.$slots, "header-extra", { transactionDetail: __props.transactionDetail })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(__props.transactionDetail.Code), 1),
                    _createElementVNode("span", {
                      class: "inline-block text-center leading-tight text-xs font-bold px-3 py-1 rounded-full border transition-all duration-200",
                      style: _normalizeStyle({
                  color: _unref(getDynamicStatusColor)(__props.transactionDetail.ApprovalStatus),
                  borderColor: _unref(getDynamicStatusColor)(__props.transactionDetail.ApprovalStatus),
                  backgroundColor: _unref(getDynamicStatusBg)(__props.transactionDetail.ApprovalStatus)
                })
                    }, _toDisplayString(_unref(getDynamicStatusText)(__props.transactionDetail.ApprovalStatus, __props.transactionDetail.ApprovalStatusDisplayName)), 5)
                  ]),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(moment)(__props.transactionDetail.CreatedAt).format('DD MMM YYYY - HH:mm:ss')), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("span", _hoisted_13, _toDisplayString(__props.transactionDetail.VehicleRegNumber || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("span", _hoisted_16, _toDisplayString(__props.transactionDetail.VehicleHullNumber || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("span", _hoisted_19, _toDisplayString(__props.transactionDetail.CrewName || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(getTransactionTypeLabel)(__props.transactionDetail.TransactionType)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_26, [
                      _createTextVNode(_toDisplayString(__props.transactionDetail.TransactionPp?.TrxId || '-'), 1)
                    ])), [
                      [
                        _directive_tooltip,
                        __props.transactionDetail.TransactionPp?.TrayekName || '-',
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("span", _hoisted_29, _toDisplayString(__props.transactionDetail.FuelTransactionVoucher?.Code || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("span", _hoisted_32, _toDisplayString(__props.transactionDetail.Liters || 0) + " L", 1)
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(formatRupiah)(__props.transactionDetail.Price)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("span", _hoisted_38, _toDisplayString(__props.transactionDetail.FuelStationPartnerOperatorName || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _createElementVNode("span", _hoisted_41, _toDisplayString(__props.transactionDetail.FuelStationPartnerName || '-'), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _createElementVNode("div", _hoisted_47, [
                      (__props.transactionDetail.MeterImageUrl)
                        ? (_openBlock(), _createBlock(ImageViewer, {
                            key: 0,
                            url: _unref(getFullImageUrl)(__props.transactionDetail.MeterImageUrl),
                            width: "300px",
                            height: "300px"
                          }, null, 8, ["url"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_48, _hoisted_51))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createElementVNode("div", _hoisted_54, [
                      (__props.transactionDetail.VehicleImageUrl)
                        ? (_openBlock(), _createBlock(ImageViewer, {
                            key: 0,
                            url: _unref(getFullImageUrl)(__props.transactionDetail.VehicleImageUrl),
                            width: "300px",
                            height: "300px"
                          }, null, 8, ["url"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_55, _hoisted_58))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _createElementVNode("div", _hoisted_61, [
                      (__props.transactionDetail.ReceiptImageUrl)
                        ? (_openBlock(), _createBlock(ImageViewer, {
                            key: 0,
                            url: _unref(getFullImageUrl)(__props.transactionDetail.ReceiptImageUrl),
                            width: "300px",
                            height: "300px"
                          }, null, 8, ["url"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_62, _hoisted_65))
                    ])
                  ])
                ])
              ]),
              _renderSlot(_ctx.$slots, "keterangan", { transactionDetail: __props.transactionDetail }, () => [
                _createElementVNode("div", {
                  class: _normalizeClass(["border-b border-neutral-100 py-6", __props.transactionDetail.FuelingTransactionRevision ? 'md:grid grid-cols-2 gap-4' : ''])
                }, [
                  _createElementVNode("div", null, [
                    _hoisted_66,
                    (__props.transactionDetail.FuelingTransactionRevision)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                          _hoisted_68,
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("div", _hoisted_70, _toDisplayString(`${_unref(numberFormat)(__props.transactionDetail.FuelingTransactionRevision?.OldLiters ?? 0)} L`), 1),
                            _hoisted_71,
                            _createElementVNode("div", _hoisted_72, _toDisplayString(`${_unref(numberFormat)(__props.transactionDetail.FuelingTransactionRevision?.NewLiters ?? 0)} L`), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (__props.transactionDetail.FuelingTransactionRevision)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                          _hoisted_74,
                          _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("div", _hoisted_76, _toDisplayString(`${_unref(formatRupiah)(__props.transactionDetail.FuelingTransactionRevision?.OldPrice ?? 0)}`), 1),
                            _hoisted_77,
                            _createElementVNode("div", _hoisted_78, _toDisplayString(`${_unref(formatRupiah)(__props.transactionDetail.FuelingTransactionRevision?.NewPrice ?? 0)}`), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_79, [
                      _hoisted_80,
                      _createElementVNode("div", _hoisted_81, [
                        (__props.transactionDetail.Notes)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (Array.isArray(__props.transactionDetail.Notes))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.transactionDetail.Notes, (note) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: note,
                                        class: "text-sm font-bold text-neutral-800 mb-1"
                                      }, _toDisplayString(note), 1))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(__props.transactionDetail.Notes), 1))
                            ], 64))
                          : (_openBlock(), _createElementBlock("span", _hoisted_84, "-"))
                      ])
                    ])
                  ]),
                  (__props.transactionDetail.FuelingTransactionRevision?.EvidenceImageUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                        _renderSlot(_ctx.$slots, "revision-evidence", {
                          evidenceImageUrl: __props.transactionDetail.FuelingTransactionRevision.EvidenceImageUrl
                        }, () => [
                          _createElementVNode("div", _hoisted_86, [
                            _hoisted_87,
                            _createElementVNode("img", {
                              src: __props.transactionDetail.FuelingTransactionRevision.EvidenceImageUrl,
                              style: {"max-height":"200px"},
                              class: "cursor-pointer rounded-lg border border-neutral-200 object-contain hover:opacity-90",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('view-evidence', __props.transactionDetail.FuelingTransactionRevision.EvidenceImageUrl))),
                              alt: "Bukti Revisi"
                            }, null, 8, _hoisted_88)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("a", {
                  href: "#",
                  class: "text-blue-500 hover:text-blue-600 text-sm font-semibold flex items-center gap-1 transition-colors duration-150",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('toggle-history')), ["prevent"]))
                }, [
                  _createTextVNode(_toDisplayString(__props.isHistoryVisible ? 'Sembunyikan' : 'Tampilkan') + " Riwayat Pengisian BBM ", 1),
                  _createElementVNode("i", {
                    class: _normalizeClass(["pi text-xs", __props.isHistoryVisible ? 'pi-chevron-up' : 'pi-angle-right'])
                  }, null, 2)
                ]),
                (__props.isHistoryVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                      _createElementVNode("p", _hoisted_91, [
                        _createTextVNode(" Berikut daftar riwayat transaksi pengisian BBM yang dilakukan oleh " + _toDisplayString(__props.activeHistoryTab === 'nopol' ? 'Nopol' : 'Kru') + ": ", 1),
                        _createElementVNode("span", _hoisted_92, _toDisplayString(__props.activeHistoryTab === 'nopol' ? (__props.transactionDetail.VehicleRegNumber || '-') : (__props.transactionDetail.CrewName || '-')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_93, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('change-history-tab', 'nopol'))),
                          class: _normalizeClass(["px-6 py-2.5 font-semibold text-sm transition-all duration-150 border-b-2 -mb-px", __props.activeHistoryTab === 'nopol' ? 'border-blue-500 text-blue-500' : 'border-transparent text-neutral-500 hover:text-neutral-700'])
                        }, " Nopol ", 2),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('change-history-tab', 'kru'))),
                          class: _normalizeClass(["px-6 py-2.5 font-semibold text-sm transition-all duration-150 border-b-2 -mb-px", __props.activeHistoryTab === 'kru' ? 'border-blue-500 text-blue-500' : 'border-transparent text-neutral-500 hover:text-neutral-700'])
                        }, " Kru ", 2)
                      ]),
                      _createElementVNode("div", _hoisted_94, [
                        (__props.isLoadingHistory)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                              _createVNode(_unref(ProgressSpinner), {
                                style: {"width":"40px","height":"40px"},
                                strokeWidth: "4"
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(DataTable), {
                          value: __props.historyData,
                          responsiveLayout: "scroll",
                          class: "excel-clone",
                          showHeader: true
                        }, {
                          empty: _withCtx(() => [
                            _hoisted_96
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(Column), {
                              field: "CreatedAt",
                              header: "TANGGAL"
                            }, {
                              body: _withCtx((slotProps) => [
                                _createTextVNode(_toDisplayString(_unref(moment)(slotProps.data.CreatedAt).format('DD/MM/YYYY - HH:mm:ss')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(Column), {
                              field: "Liters",
                              header: "PEMBELIAN BBM"
                            }, {
                              body: _withCtx((slotProps) => [
                                _createElementVNode("span", null, _toDisplayString(slotProps.data.Liters || 0) + " Liter", 1),
                                (slotProps.data.FuelTransactionVoucher)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_97, " (Kupon BBM) "))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(Column), {
                              field: "FuelStationPartnerName",
                              header: "POM BENSIN"
                            }, {
                              body: _withCtx((slotProps) => [
                                _createTextVNode(_toDisplayString(slotProps.data.FuelStationPartnerName || '-'), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(Column), {
                              field: __props.activeHistoryTab === 'kru' ? 'VehicleRegNumber' : 'CrewName',
                              header: __props.activeHistoryTab === 'kru' ? 'NOPOL' : 'NAMA KRU'
                            }, {
                              body: _withCtx((slotProps) => [
                                _createTextVNode(_toDisplayString((__props.activeHistoryTab === 'kru' ? slotProps.data.VehicleRegNumber : slotProps.data.CrewName) || '-'), 1)
                              ]),
                              _: 1
                            }, 8, ["field", "header"]),
                            _createVNode(_unref(Column), {
                              field: "Price",
                              header: "HARGA",
                              class: "text-right"
                            }, {
                              body: _withCtx((slotProps) => [
                                _createElementVNode("span", _hoisted_98, _toDisplayString(_unref(formatRupiah)(slotProps.data.Price)), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      (__props.historyPaginate.totalRecords > __props.historyPaginate.pageSize)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                            _createVNode(Paginator, {
                              first: ((__props.historyPaginate.pageNumber || 1) - 1) * (__props.historyPaginate.pageSize || 5),
                              rows: __props.historyPaginate.pageSize,
                              totalRecords: __props.historyPaginate.totalRecords,
                              onOnPage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('change-history-page', $event)))
                            }, null, 8, ["first", "rows", "totalRecords"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            footer: _withCtx(() => [
              _renderSlot(_ctx.$slots, "footer", { transactionDetail: __props.transactionDetail }, () => [
                _createElementVNode("div", _hoisted_100, [
                  _createVNode(_unref(Button), {
                    class: "btn-default bg-neutral-200 border-neutral-200 text-black hover:bg-neutral-300 w-32 justify-center",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('back')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_101
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 3
          }))
        : _createCommentVNode("", true)
  ]))
}
}

})